// ------------------ LOGGED OUT CHAT HELPER-----------------------------------

import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import { setLoggedOutChatEnabled } from '../contactUs/actions/action-login-modal';
import { channelMap } from '../common/commonConstants';
import Page from './page';

// Get remote config for logged out chat
const getLoggedOutChatConfig = () => {
  try {
    if (window && window.loggedOutChatConfig) {
      return window.loggedOutChatConfig;
    }
    return {};
  } catch (e) {
    return {};
  }
};

/**
 *  Check if the market is enabled in remote config.
 * @param loggedOutChatConfig
 * @returns {boolean}
 */
export const isLoggedOutChatLocaleEnabledInRc = (loggedOutChatConfig) => {
  if (!_isEmpty(loggedOutChatConfig) && loggedOutChatConfig.enabledLocales) {
    const country = Page.getCountry().toUpperCase();
    const locale = Page.getAPILocalilty();

    return (
      loggedOutChatConfig.enabledLocales
        .split(',')
        .filter((market) => market.indexOf(`${country}:`) >= 0)
        .filter((selectedMarket) => selectedMarket.split(':')[1].indexOf(locale) >= 0).length > 0
    );
  }

  return false;
};

/**
 * Checks if logged out chat is enabled globally in RC
 * @param loggedOutChatConfig
 * @returns {boolean}
 */
export const isLoggedOutChatEnabledGlobally = (loggedOutChatConfig) => {
  if (!_isEmpty(loggedOutChatConfig)) {
    return loggedOutChatConfig.enableGlobally || false;
  }
  return false;
};

/**
 * Checks if the selected intent is enabled for logged out chat in remote config
 * @param intentId
 * @param loggedOutChatConfig
 * @returns {boolean}
 */
export const isLoggedOutChatEnabledIntent = (intentId, loggedOutChatConfig) => {
  if (_isEmpty(intentId)) {
    return false;
  }

  if (!_isEmpty(loggedOutChatConfig) && loggedOutChatConfig.enabledIntents) {
    return (
      Array.isArray(loggedOutChatConfig.enabledIntents) && loggedOutChatConfig.enabledIntents.indexOf(intentId) >= 0
    );
  }
  return false;
};

/**
 * Check if live chat is available in IDI response.
 * If the availability decision reason is 'OUT_OF_SUPPORT_HOURS' then live chat is not available other than this reason it is true for all other reasons.
 * @param idiContactChannels
 * @returns {boolean}
 */
export const isLiveChatAvailable = (idiContactChannels) => {
  let contactChannel = null;

  if (Array.isArray(idiContactChannels) && idiContactChannels.length) {
    if (Page.isPilotUser()) {
      contactChannel = idiContactChannels.find((channel) => channel.name === channelMap.message);
    } else {
      contactChannel = idiContactChannels.find((channel) => channel.name === channelMap.chat);
    }
  }

  if (contactChannel && typeof contactChannel === 'object') {
    const availabilityDecisionReason = _get(contactChannel, 'availability_decision_reason.decision_reason', '');
    return availabilityDecisionReason !== 'OUT_OF_SUPPORT_HOURS';
  }

  return false;
};

/**
 * Function to determine is logged out chat is enabled/disabled
 * @param topicRefId
 * @param loggedOutChatConfig
 * @param idiContactChannels
 * @returns {boolean}
 */
export const isLoggedOutChatEnabled = (topicRefId, loggedOutChatConfig, idiContactChannels) => {
  // Check if selected intent is enabled in RC for logged out chat.
  // If not enabled return false in the first step it self.
  if (!isLoggedOutChatEnabledIntent(topicRefId, loggedOutChatConfig)) {
    return false;
  }

  // If logged out chat is enabled globally and if live chat is available return true.
  if (isLoggedOutChatEnabledGlobally(loggedOutChatConfig)) {
    return isLiveChatAvailable(idiContactChannels); // IDI Availability check
  }

  // If enabledGlobally is set to false then check if the current market is part of remote config enabled markets.
  // IF market is part of the remote config then check if live chat is available.
  return isLoggedOutChatLocaleEnabledInRc(loggedOutChatConfig) && isLiveChatAvailable(idiContactChannels);
};

/**
 *  This method will check if the selected topic is logged out chat enabled
 *  This method will perform multiple checks to validate if logged out chat is enabled or not.
 *
 *  If enabled will show a "chat with us " link in login modal window
 *  If not Fallback will be old login modal window.
 *
 * @param topicRefId
 * @returns {*}
 */
export const requestLoggedOutChatValidation = (topicRefId) => (dispatch, getState) => {
  const loggedOutChatConfig = getLoggedOutChatConfig();
  const state = getState();
  const idiChannels = _get(state, 'contactChannels.OriginalRiskResponse', []);
  return dispatch(setLoggedOutChatEnabled(isLoggedOutChatEnabled(topicRefId, loggedOutChatConfig, idiChannels)));
};

/**
 * Function to check logged out chat captcha in RC
 */
export const isLoggedOutChatCaptchaEnabled = () => {
  const loggedOutChatConfig = getLoggedOutChatConfig();
  if (!_isEmpty(loggedOutChatConfig)) {
    return loggedOutChatConfig.enableCaptchaGlobally || false;
  }
  return false;
};

// ------------------ END OF LOGGED OUT CHAT ----------------------------
